import { useQueryClient } from '@tanstack/react-query';
import React from 'react';

/**
 * "Try again" for a section or page whose data didn't load: refetches only
 * the mounted queries that are in an error state, so the rest of the page
 * keeps its data.
 */
export function useRetryFailedQueries() {
  // Hooks
  const queryClient = useQueryClient();

  return React.useCallback(() => {
    queryClient.refetchQueries({
      type: 'active',
      predicate: (query) => query.state.status === 'error',
    });
  }, [queryClient]);
}
